import { LightbulbOn10Icon } from './LightbulbOn10Icon';

/**
 * author: Michael Irigoyen
 * id 5AF7B110-A35F-437B-B4F2-5DAED54DE86F
 * name lightbulb-on-10
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-on-10.svg
 * tags
 * - Home Automation 
 */
export const LightbulbDimmer10Icon = LightbulbOn10Icon;
export default LightbulbDimmer10Icon